<template>
  <div>
    <span v-if="!edit_name"
          class="transition duration-200 hover:text-primary cursor-pointer"
          @click="editSessionName">{{ name }}</span>
    <input v-else
           class="focus:outline-none px-1 -m-1 border rounded border-gray-light"
           v-model="session_name"
           type="text"
           @focusout="applySessionName"
           @keypress.enter="applySessionName"
           ref="session_name">
  </div>
</template>

<script>
export default {
  name: "Name",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      edit_name: false,
      session_name:''
    }
  },
  methods: {
    editSessionName() {
      this.edit_name = true;
      this.session_name = this.name || ''
      setTimeout(() => {
        this.$refs.session_name.focus()
      })
    },
    applySessionName() {
      if (this.session_name !== this.name && this.session_name !== '') {
        this.$emit('change', {name: this.session_name})
      }
      this.edit_name = false;
    }
  }
}
</script>